import { createApp } from 'vue';
import App from './App.vue';
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap";
import axios from "axios";
import router from "../router/router.js";
import PrimeVue from 'primevue/config';
import Tooltip from 'primevue/tooltip';
import ConfirmationService from 'primevue/confirmationservice';
import store from '../src/store/index.js';
import phoneDirective from './directives/phone.js';
import { useSubsGateStore } from '@/stores/useSubsGateStore.js';
import { createPinia } from 'pinia';
import print from "vue3-print-nb";
import 'primeicons/primeicons.css'
import Aura from '@primeuix/themes/aura';
import '@/assets/scss/style.min.css'
import '@/assets/scss/design-system.css'
import '@/assets/css/themes/dark.css'
import '@/assets/css/themes/light.css'
import { initTheme } from '@/services/themeService.js'

initTheme()

axios.defaults.baseURL = localStorage.getItem("api_base_url") || "https://api.tarekmath.com/api";
// axios.defaults.baseURL = "http://192.168.1.26:8000/api";

const token = localStorage.getItem("token");
if (token) {
    axios.defaults.headers.common["Authorization"] = `Bearer ${localStorage.getItem("token")}`;
}

// TEMP DEBUG: logs the fully-resolved request right before dispatch (remove after 403 investigation)
axios.interceptors.request.use((config) => {
    const isFormData = typeof FormData !== 'undefined' && config.data instanceof FormData;
    console.log('[axios request]', {
        method: config.method,
        url: (config.baseURL || '') + config.url,
        headers: { ...config.headers },
        dataType: isFormData ? 'FormData' : typeof config.data,
        dataPreview: isFormData
            ? Array.from(config.data.entries()).map(([k, v]) => [k, typeof v === 'string' ? v.slice(0, 80) : v])
            : config.data,
    });
    return config;
});

// Backend enforcement of the subscriptions/payments gate: if the section's TTL
// expires WHILE THE USER IS ON A PROTECTED PAGE, the API replies 403
// SUBS_GATE_REQUIRED — re-lock and send them to the gate for THAT page.
//
// Critically, this must NOT navigate for a background call to a gated API made
// from a NON-protected page (e.g. the pending-payments badge that the navbar and
// dashboard Home fetch on every load). Such a 403 is expected while locked and
// must leave Home/Courses/etc. exactly where they are — only the caller's own
// .catch handles it. Guarding on "current route is protected" is what keeps Home
// from ever being redirected to /subscriptions-gate.
axios.interceptors.response.use(
    (res) => res,
    (error) => {
        if (error?.response?.status === 403 && error?.response?.data?.code === 'SUBS_GATE_REQUIRED') {
            try {
                const current = router.currentRoute.value;
                const onProtectedRoute = current?.matched?.some(r => r.meta?.requiresSubsGate);
                if (onProtectedRoute && current?.name !== 'SubscriptionsGate') {
                    useSubsGateStore().reset();
                    router.replace({ path: '/subscriptions-gate', query: { redirect: current.fullPath } });
                }
            } catch (e) { /* non-fatal */ }
        }
        return Promise.reject(error);
    }
);
const app = createApp(App);
app.config.globalProperties.axios = axios;
const pinia = createPinia();
app.use(pinia);
app.use(PrimeVue, {
    theme: {
        preset: Aura,
        options: {
            prefix: 'p',
            darkModeSelector: false,
            cssLayer: false
        }
    }
});
app.use(router);
app.use(print);
app.use(store);
app.use(ConfirmationService);
app.directive('tooltip', Tooltip);
app.directive('phone', phoneDirective);
app.mount('#app');